import React, { useMemo, useState } from "react";
import CardContainer from "../../components/card/card-container.jsx";
import SelectCiclo from "../../components/select/select-ciclo.jsx";
import Api from "../../api/global.service";
import env from "../../environment.js";
import { useAuth } from "../../components/content/auth.jsx";
import useEtiquetas from '../../hooks/useEtiquetas'
import transformWord from '../../utils/transformWord'

const pillBaseStyle = {
  padding: "6px 18px",
  borderRadius: "20px",
  fontSize: "0.9rem",
  cursor: "pointer",
  border: "1px solid #789D16",
  transition: "background-color 0.15s, color 0.15s",
};

const pillActiveStyle = {
  ...pillBaseStyle,
  backgroundColor: "#789D16",
  color: "white",
  fontWeight: "500",
};

const pillInactiveStyle = {
  ...pillBaseStyle,
  backgroundColor: "white",
  color: "#789D16",
};

const hamsterStyles = `
  @keyframes hamsterRun {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-4px); }
  }
  @keyframes hamsterBlink {
    0%, 90%, 100% { opacity: 1; }
    95%           { opacity: 0; }
  }
  .hamster-group {
    animation: hamsterRun 0.35s ease-in-out infinite;
    transform-box: fill-box;
    transform-origin: center;
  }
  .hamster-eye {
    animation: hamsterBlink 3s infinite;
  }
`;

const HamsterSirio = () => (
  <>
    <style>{hamsterStyles}</style>
    <svg
      width="100%"
      viewBox="0 100 680 330"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%", display: "block", margin: "0 auto" }}
    >
      <title>Hámster Sirio</title>
      <desc>Hámster Sirio, el motor (no oficial) de tus reportes</desc>

      {/* aro exterior */}
      <circle
        cx="340"
        cy="268"
        r="110"
        fill="none"
        stroke="#b08040"
        strokeWidth="10"
      />
      {/* radios */}
      <line
        x1="340"
        y1="158"
        x2="340"
        y2="378"
        stroke="#c89a50"
        strokeWidth="4"
      />
      <line
        x1="230"
        y1="268"
        x2="450"
        y2="268"
        stroke="#c89a50"
        strokeWidth="4"
      />
      <line
        x1="252"
        y1="190"
        x2="428"
        y2="346"
        stroke="#c89a50"
        strokeWidth="4"
      />
      <line
        x1="252"
        y1="346"
        x2="428"
        y2="190"
        stroke="#c89a50"
        strokeWidth="4"
      />
      {/* aro interior */}
      <circle
        cx="340"
        cy="268"
        r="72"
        fill="none"
        stroke="#b08040"
        strokeWidth="5"
      />
      {/* peldaños */}
      <circle
        cx="340"
        cy="268"
        r="110"
        fill="none"
        stroke="#8B5E1A"
        strokeWidth="2"
        strokeDasharray="14 8"
      />

      {/* soporte */}
      <rect x="320" y="370" width="40" height="18" rx="4" fill="#7a5030" />
      <rect x="280" y="385" width="120" height="10" rx="4" fill="#5a3820" />

      {/* eje */}
      <circle cx="340" cy="268" r="10" fill="#7a5030" />
      <circle cx="340" cy="268" r="5" fill="#a07040" />

      {/* hámster */}
      <g className="hamster-group" style={{ transformOrigin: "340px 290px" }}>
        <ellipse cx="340" cy="310" rx="46" ry="38" fill="#E8A830" />
        <ellipse cx="340" cy="322" rx="28" ry="24" fill="#F5D080" />
        <ellipse cx="304" cy="302" rx="22" ry="17" fill="#EBB840" />
        <ellipse cx="376" cy="302" rx="22" ry="17" fill="#EBB840" />
        <ellipse cx="340" cy="272" rx="36" ry="33" fill="#E8A830" />
        <ellipse cx="312" cy="248" rx="14" ry="12" fill="#E8A830" />
        <ellipse cx="312" cy="248" rx="8" ry="7" fill="#F2C0B0" />
        <ellipse cx="368" cy="248" rx="14" ry="12" fill="#E8A830" />
        <ellipse cx="368" cy="248" rx="8" ry="7" fill="#F2C0B0" />
        <circle
          cx="326"
          cy="266"
          r="7"
          fill="#1a1a1a"
          className="hamster-eye"
        />
        <circle
          cx="354"
          cy="266"
          r="7"
          fill="#1a1a1a"
          className="hamster-eye"
        />
        <circle cx="328" cy="263" r="2.5" fill="white" />
        <circle cx="356" cy="263" r="2.5" fill="white" />
        <ellipse cx="340" cy="279" rx="5" ry="4" fill="#d47080" />
        <path
          d="M333 286 Q340 291 347 286"
          stroke="#c05060"
          strokeWidth="1.8"
          fill="none"
          strokeLinecap="round"
        />
        <line
          x1="334"
          y1="280"
          x2="304"
          y2="275"
          stroke="#a07030"
          strokeWidth="1.2"
        />
        <line
          x1="334"
          y1="283"
          x2="302"
          y2="283"
          stroke="#a07030"
          strokeWidth="1.2"
        />
        <line
          x1="346"
          y1="280"
          x2="376"
          y2="275"
          stroke="#a07030"
          strokeWidth="1.2"
        />
        <line
          x1="346"
          y1="283"
          x2="378"
          y2="283"
          stroke="#a07030"
          strokeWidth="1.2"
        />
        <ellipse
          cx="320"
          cy="342"
          rx="14"
          ry="7"
          fill="#EBB840"
          transform="rotate(-20 320 342)"
        />
        <ellipse
          cx="360"
          cy="342"
          rx="14"
          ry="7"
          fill="#EBB840"
          transform="rotate(20 360 342)"
        />
        <ellipse
          cx="305"
          cy="320"
          rx="11"
          ry="7"
          fill="#E8A830"
          transform="rotate(30 305 320)"
        />
        <ellipse
          cx="375"
          cy="320"
          rx="11"
          ry="7"
          fill="#E8A830"
          transform="rotate(-30 375 320)"
        />
        <line
          x1="386"
          y1="258"
          x2="398"
          y2="252"
          stroke="#E8A830"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="390"
          y1="265"
          x2="404"
          y2="263"
          stroke="#E8A830"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="386"
          y1="272"
          x2="399"
          y2="274"
          stroke="#E8A830"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>

      {/* caption */}
      <text
        x="340"
        y="418"
        textAnchor="middle"
        fontSize="12"
        fill="#aaa"
        fontFamily="sans-serif"
        fontStyle="italic"
      >
        Hámster Sirio, el motor (no oficial) de tus reportes
      </text>
    </svg>
  </>
);

const CooperativasGeneralReport = () => {
  const auth = useAuth();
  const [ciclo, setCiclo] = useState({});
  const [agruparPorEstado, setAgruparPorEstado] = useState(true);
  const [blocking, setBlocking] = useState(false);
  const { etiquetas } = useEtiquetas();

  const queryParams = useMemo(() => {
    const params = new URLSearchParams({
      id_ciclo: String(ciclo?.id || ""),
      agrupar_por_estado: agruparPorEstado ? "1" : "0",
    });
    return params.toString();
  }, [ciclo, agruparPorEstado]);

  const setFilter = (value) => {
    setCiclo(value.target || {});
  };

  const handleDownload = async (event) => {
    event.preventDefault();
    if (!ciclo?.id || blocking) return;

    setBlocking(true);

    try {
      const response = await Api.download(
        `reports/general-cooperatives/download?${queryParams}`,
      );
      const fileName =
        response.headers["content-disposition"]?.split("filename=")[1] ||
        "reporte_general_cooperativas.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName.replace(/"/g, ""));
      link.click();
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
    } catch (error) {
      console.error("Error downloading general cooperatives report:", error);
    } finally {
      setBlocking(false);
    }
  };

  return (
    <div>
      {auth.hasAccess("COOPERATIVAS") && (
        <CardContainer height={"100%"}>
          <div className="mb-0">
            <h3 className="mb-1">Reporte general de las cooperativas</h3>
            <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
              Este reporte incluye, por cooperativa, los módulos habilitados
              (SIC, acopio, EUDR y calidad), el número de productores, {transformWord(etiquetas?.parcela, ['plural','lowercase'])}
              y su superficie, así como los riesgos EUDR asociados, entre otros
              indicadores.
            </p>
          </div>

          <div className="row align-items-start mt-3">
            {/* columna izquierda: controles */}
            <div className="col-12 col-md-5 mb-4 mb-md-0">
              <div style={{ maxWidth: "380px" }}>
                <label
                  className="font-weight-bold d-block mb-2"
                  style={{ fontSize: "1rem" }}
                >
                  Ciclo
                </label>
                <SelectCiclo
                  className="w-100"
                  setFilter={setFilter}
                  width="100%"
                />

                <div className="mt-3 mb-2">
                  <label
                    className="font-weight-bold d-block mb-2"
                    style={{ fontSize: "1rem" }}
                  >
                    Agrupar por estado/departamento
                  </label>
                  <div className="d-flex" style={{ gap: "8px" }}>
                    <button
                      type="button"
                      style={
                        agruparPorEstado ? pillActiveStyle : pillInactiveStyle
                      }
                      onClick={() => setAgruparPorEstado(true)}
                    >
                      Sí
                    </button>
                    <button
                      type="button"
                      style={
                        !agruparPorEstado ? pillActiveStyle : pillInactiveStyle
                      }
                      onClick={() => setAgruparPorEstado(false)}
                    >
                      No
                    </button>
                  </div>
                  <small className="text-muted d-block mt-2">
                    {agruparPorEstado
                      ? "Los resultados se separarán por estado/departamento de la cooperativa."
                      : "Los resultados se mostrarán sin agrupar por estado/departamento."}
                  </small>
                </div>

                <button
                  onClick={handleDownload}
                  disabled={!ciclo?.id || blocking}
                  className="btn btn-sirio d-flex align-items-center justify-content-center w-100 mt-3"
                  type="button"
                  title="Descargar Excel"
                >
                  {blocking ? (
                    <span className="d-inline-flex align-items-center">
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Descargando...
                    </span>
                  ) : (
                    <span className="d-inline-flex align-items-center">
                      <img
                        src={env.images.icon.xls}
                        className="pr-1"
                        alt="Excel"
                      />
                      Descargar Excel
                    </span>
                  )}
                </button>
              </div>
            </div>

            {/* columna derecha: hámster */}
            <div
              className="col-12 col-md-7 d-flex justify-content-center align-items-start"
              style={{ minHeight: "420px" }}
            >
              <HamsterSirio />
            </div>
          </div>
        </CardContainer>
      )}
    </div>
  );
};

export default CooperativasGeneralReport;
